import { render, staticRenderFns } from "./ItemHome.vue?vue&type=template&id=b2dd041a&scoped=true&"
import script from "./ItemHome.vue?vue&type=script&lang=ts&"
export * from "./ItemHome.vue?vue&type=script&lang=ts&"
import style0 from "./ItemHome.vue?vue&type=style&index=0&id=b2dd041a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dd041a",
  null
  
)

export default component.exports